<template>
    <div class="win">
        <div class="header">
            <div class="navItem">
                <i class="iconfont icon-lishishuju"></i>
                <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px':''}">{{ $t('ems.History') }}</div>
                <div class="desc">{{ $t('ems.his.desc') }}</div>
            </div>
            <div class="navRight">
                <template v-if="false">
                    <div class="creatTime" v-if="updateTime">{{ $t('ems.history.DataUpdateTime') }}<span>{{updateTime}}</span></div>
                    <div class="btn" @click="fresh"><i class="iconfont icon-shuaxin"></i>{{ $t('ems.history.refresh') }}</div>
                    <div class="btn" style="width: 110px"  @click="fresh"><i class="iconfont icon-banbengengxin"></i>{{ $t('ems.history.UpdateTheData') }}</div>
                </template>
            </div>
        </div>
        <div class="content" v-loading="loading"  element-loading-text="Loading"  element-loading-spinner="el-icon-loading"  element-loading-background="rgba(42, 43, 44, 0.6)">
            <div class="table_box">
                <div class="topContent">
                        <div class="leftbox">
                            <div
                                    class="item"
                                    :class="{ active: active == 0 }"
                                    @click="tabChange(0)"
                            >
                                <span>{{ $t("bms.cluster.daily") }}</span>
                                <div class="triangle" v-if="active == 0"></div>
                            </div>
                            <div
                                    class="item"
                                    :class="{ active: active == 2 }"
                                    @click="tabChange(2)"
                            >
                                <span>{{ $t("bms.cluster.month") }}</span>
                                <div class="triangle" v-if="active == 2"></div>
                            </div>
                            <div
                                    class="item"
                                    :class="{ active: active == 3 }"
                                    @click="tabChange(3)"
                            >
                                <span>{{ $t("bms.cluster.year") }}</span>
                                <div class="triangle" v-if="active == 3"></div>
                            </div>
                        </div>
                        <div class="rightbox">
                            <el-form
                                    class="table_header tableSearchForm"
                                    :inline="true"
                                    size="small"
                                    label-width="80px"
                                    label-position="left"
                            >

                                <el-form-item v-if="active === 0">
                                    <el-date-picker key="day1" v-model="time1" type="date" placeholder="选择日期" popper-class="dateDown" style="width: 150px; margin-right: 10px">
                                    </el-date-picker>
                                    <el-time-picker
                                            key="day2"
                                            is-range
                                            v-model="time"
                                            :range-separator="$t('bms.cluster.to')"
                                            :start-placeholder="$t('bms.cluster.StartDate')"
                                            :end-placeholder="$t('bms.cluster.EndDate')"
                                            style="width: 300px; padding-top: 2px"
                                            popper-class="dateDown"
                                            :clearable="false"
                                    >
                                    </el-time-picker>
                                </el-form-item>
                                <el-form-item style="width: 400px" v-else>
                                    <el-date-picker
                                            key="day2"
                                            v-model="time"
                                            :type="dateType"
                                            :range-separator="$t('bms.cluster.to')"
                                            :start-placeholder="$t('bms.cluster.StartDate')"
                                            :end-placeholder="$t('bms.cluster.EndDate')"
                                            style="width: 100%"
                                            popper-class="dateDown"
                                    >
                                    </el-date-picker>
                                </el-form-item>
                                <div class="btn btn_active" @click="search">
                                    <i class="iconfont icon-sousuo"></i
                                    ><span>{{ $t("bms.cluster.search") }}</span>
                                </div>
                            </el-form>
                        </div>
                    </div>
                <div class="chart" ref="powerChart"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getDatapowerHisDay, getDatapowerHismonth, getDatapowerHisyear} from "@/api/spms";
    import { getStore } from "@/utils/store";
    import moment from "moment";
    import i18n from "@/lang";
    import {mapGetters} from "vuex";

    export default {
        name: "historySys",
        data(){
            return {
                groupNo: getStore({name: "siteNo"})||"",
                updateTime: "",
                loading: false,

                isLoading: false,
                listLoading: true,

                active: 0,
                dateType: "daterange",
                powerChart: null,
                time1: moment(),
                time:  [moment().startOf('d'), moment()],
            }
        },
        computed:{
            ...mapGetters(["language", "systemMenu", "systemSet"])
        },
        created(){
        },
        mounted(){
            setTimeout(() => {
                this.tabChange(0);
            }, 800)
        },
        methods: {
            search() {
                this.names = [];
                this.series = [];
                this.loadData();
            },
            tabChange(index) {
                this.active = index;
                if (index == 0) {
                    this.dateType = "daterange";
                    this.time = [moment().startOf('d'), moment().endOf('d')];
                }
                if (index == 2) {
                    this.dateType = "daterange";
                    this.time = [moment().subtract(30, "d").startOf('d'), moment().endOf('d')];
                }
                if (index == 3) {
                    this.dateType = "monthrange";
                    this.time = [moment().subtract(1, "y").startOf('month').startOf('d'), moment().endOf('month').endOf('d')];
                }
                this.names = [];
                this.series = [];
                this.loadData();
            },
            loadData(){
                this.loading = true;
                const params = {};
                params.groupNo = this.groupNo;
                if (this.active === 0) {
                    params.startTime =  moment(this.time1).format("YYYY-MM-DD") + " " + moment(this.time[0]).format("HH:mm:ss");
                    params.endTime =  moment(this.time1).format("YYYY-MM-DD") + " " + moment(this.time[1]).format("HH:mm:ss");
                } else if(this.active === 2) {
                    params.startTime = moment(this.time[0]).startOf('d').format("YYYY-MM-DD HH:mm:ss");
                    params.endTime = moment(this.time[1]).endOf('d').format("YYYY-MM-DD HH:mm:ss");
                }else {
                    params.startTime = moment(this.time[0]).startOf('month').startOf('d').format("YYYY-MM-DD HH:mm:ss");
                    params.endTime = moment(this.time[1]).endOf('month').endOf('d').format("YYYY-MM-DD HH:mm:ss");
                }
                params.beginCollectTime = moment(params.startTime, "YYYY-MM-DD HH:mm:ss").valueOf();
                params.endCollectTime = moment(params.endTime, "YYYY-MM-DD HH:mm:ss").valueOf();
                let fn;
                if(this.active === 0){
                    fn = getDatapowerHisDay;
                }else if(this.active === 2) {
                    if(moment(params.endTime, "YYYY-MM-DD HH:mm:ss").diff(moment(params.startTime, "YYYY-MM-DD HH:mm:ss"), 'd') > 60){
                        this.$message.warning(i18n.t("ems.his.timeLongTips1"));
                        return;
                    }
                    fn =  getDatapowerHismonth;
                }else{
                    console.log(moment(params.endTime, "YYYY-MM-DD HH:mm:ss").diff(moment(params.startTime, "YYYY-MM-DD HH:mm:ss"), 'M'));
                    if(moment(params.endTime, "YYYY-MM-DD HH:mm:ss").diff(moment(params.startTime, "YYYY-MM-DD HH:mm:ss"), 'M') > 24){
                        this.$message.warning(i18n.t("ems.his.timeLongTips2"));
                        return;
                    }
                    fn =  getDatapowerHisyear;
                }
                fn(params).then(res => {
                    this.loading = false;
                    this.renderPowerChart(this.formatField(res.data.data));
                }).catch(err => {
                    console.log(err);
                });
            },
            handleSizeChange(val) {
                this.page = 1;
                this.size = val;
                this.loadData();
            },
            handleCurrentChange(val) {
                this.page = val;
                this.loadData();
            },
            reset(){
                this.form= {
                    logContent: "",
                        logStatus: "",
                        logType: "",
                        time: ""
                };
                this.page= 1;
                this.loadData();
            },
            formatField(str){
                console.log("开始时间：" + moment());
                if(!str.collectDate){ return false }
                const collectTime = [];
                for(let key in str.collectDate){
                    const temp =  str.collectDate[key].split(",");
                    for (let i of temp){
                        collectTime.push(moment(key + " " + i, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"))
                    }
                }
                const change = (data) => {
                    const list = data.split(",");
                    if(list.length === 0) return [];
                    let temp = "";
                    let result = [];
                    list.forEach((item) => {
                        if(item !== ""){
                            temp = item;
                            result.push(+item);
                        }else{
                            result.push(+temp);
                        }
                    });
                    return result;
                }
                const bkkfzPower = change(str.bkkfzPower);
                const cnPower = change(str.cnPower);
                const gfPower = change(str.gfPower);
                const sdPower = change(str.sdPower);
                console.log("结束时间：" + moment());
                return {collectTime, bkkfzPower, cnPower, gfPower, sdPower};
            },
            renderPowerChart(data){
                if(!this.powerChart && this.$refs.powerChart){
                    this.powerChart = this.$echarts.init(this.$refs.powerChart);
                }
                const option = {
                    tooltip: {
                        trigger: 'axis',
                        backgroundColor: 'rgba(59,59,59,0.8)',
                        textStyle: {
                            color: "#fff",
                        },
                        borderWidth: 0,
                    },
                    grid: {
                        top: '10%',
                        left: '3%',
                        right: '3%',
                        bottom: '10%',
                        containLabel: true
                    },
                    legend: {
                        // data: [i18n.t("ems.EnergyStorage"), i18n.t("ems.load"), i18n.t("ems.grid"), i18n.t("ems.Photovoltaic")],
                        icon: 'rect',
                        itemWidth: 40,  // 设置宽度
                        itemHeight: 20, // 设置高度
                        itemGap: 20,
                        textStyle: {
                            color:  this.$themeOption.title,
                            fontSize: 16
                        }
                    },
                    color: ['#2b8a5c', '#a14251', '#44cdea', '#eb9137'],
                    xAxis: [
                        {
                            type: 'category',
                            data: data.collectTime.map(i => { return i.replace(' ', '\n');}),
                            axisPointer: {
                                type: 'shadow'
                            },
                            axisLine: {
                                lineStyle: {
                                    color:  this.$themeOption.labelY,
                                }
                            },
                            axisTick: {
                                alignWithLabel: true
                            },
                            boundaryGap: false,
                        }
                    ],
                    yAxis: [
                        {
                            name: `kW`,
                            type: 'value',
                            show: true,
                            // min: 0,
                            // max: 2.5,
                            axisLabel: {
                                formatter: '{value}',
                                color:  this.$themeOption.labelY,
                            },
                            axisLine: {
                                lineStyle: {
                                    color:  this.$themeOption.labelY,
                                },
                                show: true
                            },
                            axisTick: {
                                show: true
                            },
                            splitLine: {
                                lineStyle:
                                    {
                                        type: 'dashed',
                                        // dashOffset: 10
                                        color:  this.$themeOption.labelY,
                                    }
                            }
                        },
                        // {
                        //     type: 'value',
                        //     name: 'Temperature',
                        //     min: 0,
                        //     max: 25,
                        //     interval: 5,
                        //     axisLabel: {
                        //         formatter: '{value} °C'
                        //     }
                        // }
                    ],
                    dataZoom: [
                        {
                            type: 'inside',
                            start: 0,
                            end: 100,
                        },
                        {
                            start: 0,
                            end: 100,
                            backgroundColor: 'rgba(81,81,81,0.25)',
                            borderColor: 'rgba(0, 0, 0, 0)',
                            dataBackground: {areaStyle:  {color: '#0acfe6'}},
                            fillerColor: 'rgba(6,93,185,0.31)',
                        }
                    ],
                    series: [
                        {
                            name: i18n.t("ems.EnergyStorage"),
                            type: 'line',
                            smooth: true,
                            data: data.cnPower,
                            emphasis: {
                                focus: 'series',
                            }
                        },

                        {
                            name: i18n.t("ems.grid"),
                            type: 'line',
                            smooth: true,
                            data: data.sdPower,
                            emphasis: {
                                focus: 'series',
                            }
                        },

                    ]
                };
                const loadCalc = this.systemSet.loadCalc !== undefined && this.systemSet.loadCalc !== null && (+this.systemSet.loadCalc) > 0;
                if (this.systemMenu.BKKFZ || loadCalc) {
                    option.series.push(   {
                        name: i18n.t("ems.load"),
                        type: 'line',
                        smooth: true,
                        data:data.bkkfzPower,
                        emphasis: {
                            focus: 'series',
                        }
                    });
                }
                if(this.systemMenu.GF) {option.series.push({
                    name: i18n.t("ems.Photovoltaic"),
                    type: 'line',
                    smooth: true,
                    data: data.gfPower,
                    legendHoverLink: true,
                    emphasis: {
                        focus: 'series',
                        blurScope: 'coordinateSystem'
                    }
                });}
                this.powerChart.setOption(option);
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../../styles/site";
    @import "@/styles/common";
    .win{
        transition: all 0.5s linear;
        width: 100%;
        height: 100%;
        .header{
            height: 52px;
            background-color: var(--nav_inner);
            position: relative;
            .navItem{
                height: 100%;
                color: $font_bright_blue_title;
                display: flex;
                align-items: center;
                transition: all 0.3s linear;
                i{
                    font-size: 22px;
                    margin: 3px 20px 0;
                }
                .title{
                    letter-spacing: 3px;
                    font-size: 22px;
                }
                .desc{
                    margin-left: 24px;
                    font-size: 16px;
                    color: $_128_128_128;
                }
            }
            .navRight{
                position: absolute;
                height: 100%;
                right: 0;
                top: 0;
                display: flex;
                align-items: center;
                .creatTime{
                    font-size: 18px;
                    color: $_191_191_191;
                    margin-right: 40px;
                    span{
                        padding-left: 20px;
                        color: $font_bright_blue_title
                    }
                }
                .btn{
                    height: 30px;
                    width: 85px;
                    border: $font_bright_blue_title solid 2px;
                    margin-right: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 16px;
                    color: $font_bright_blue_title;
                    cursor: pointer;
                    -webkit-tap-highlight-color:rgba(0,0,0,0);
                    i{
                        margin-right: 5px;
                        font-size: 18px;
                    }
                }
            }
        }
        .content{
            height: calc(100% -  52px);
            padding: 0 30px;
            overflow: hidden;
        }
        .table_box{
            .table_header{
                margin-top: 20px;
                height: 30px;
                margin-bottom: 20px;
            }
            .page{
                margin-top: 10px;
            }

            .chart {
                width: 100%;
                height: 700px;
                margin-top: 40px;
            }
            .topContent {
                height: 70px;
                border-bottom: 1px dashed $label_font_active;
                position: relative;
                .leftbox {
                    display: flex;
                    position: absolute;
                    top: 20px;
                    left: 20px;
                    .item {
                        width: 68px;
                        height: 30px;
                        color: var(--font_white);
                        border: 1px solid var(--font_white);
                        text-align: center;
                        line-height: 30px;
                        margin-right: 15px;
                        font-size: 14px;
                        cursor: pointer;
                        -webkit-tap-highlight-color:rgba(0,0,0,0);
                        position: relative;
                        .triangle {
                            width: 0;
                            height: 0;
                            border: 10px solid transparent;
                            border-bottom: 16px solid #65d3ef;
                            position: absolute;
                            top: 22px;
                            left: 24px;
                        }
                    }
                    .active {
                        color: #65d3ef;
                        border-color: #65d3ef;
                    }
                }
                .rightbox {
                    position: absolute;
                    top: 0px;
                    right: 20px;
                    .btn {
                        display: inline-block;
                        height: 28px;
                        width: 80px;
                        color: $_191_191_191;
                        border: $_191_191_191 solid 2px;
                        margin-right: 20px;
                        font-size: 15px;
                        cursor: pointer;
                        -webkit-tap-highlight-color:rgba(0,0,0,0);
                        transition: all 300ms linear;
                        line-height: 26px;
                        text-align: center;
                        i {
                            margin-right: 5px;
                            font-size: 18px;
                        }
                        span {
                            margin-top: -2px;
                        }
                    }
                    .btn_active {
                        border: $font_bright_blue_title solid 2px;
                        color: $font_bright_blue_title;
                    }
                }
            }
        }
        .btn {
            display: inline-block;
            height: 28px;
            width: 80px;
            color: $_191_191_191;
            border: $_191_191_191 solid 2px;
            font-size: 15px;
            cursor: pointer;
            -webkit-tap-highlight-color:rgba(0,0,0,0);
            transition: all 300ms linear;
            line-height: 26px;
            text-align: center;
            i {
                margin-right: 5px;
                font-size: 18px;
            }
            span{
                margin-top: -2px;
            }
        }
        .btn_active{
            border: $font_bright_blue_title solid 2px;
            color: $font_bright_blue_title;
        }
    }
</style>